export const customFilterFn = (row, columnId, filterValue) => {
  let rawValue = row.getValue(columnId);
  let cellValues = [];

  try {
    const parsed = typeof rawValue === "string" ? JSON.parse(rawValue) : rawValue;

    if (Array.isArray(parsed)) {
      cellValues = parsed
        .filter((item) => item && typeof item === "object")
        .map((item) => {
          return (item.value ?? item.email)?.toString().toLowerCase() ?? "";
        });
    } else if (parsed && typeof parsed === "object") {
      if (columnId === "delegations" && "email" in parsed) {
        cellValues = [parsed.email?.toString().toLowerCase() ?? ""];
      } else if ("value" in parsed) {
        cellValues = [parsed.value?.toString().toLowerCase() ?? ""];
      }
    } else {
      cellValues = [parsed?.toString().toLowerCase() ?? ""];
    }
  } catch (e) {
    cellValues = [rawValue?.toString().toLowerCase() ?? ""];
  }

  const keyword = filterValue?.keyword?.toString().toLowerCase() ?? "";
  const condition = filterValue?.condition;

  switch (condition) {
    case "Is":
      return cellValues.some((val) => val === keyword);
    case "Isn't":
      return cellValues.every((val) => val !== keyword);
    case "Contains":
      return cellValues.some((val) => val.includes(keyword));
    case "Doesn't Contain":
      return cellValues.every((val) => !val.includes(keyword));
    case "StartsWith":
      return cellValues.some((val) => val.startsWith(keyword));
    case "EndsWith":
      return cellValues.some((val) => val.endsWith(keyword));
    case "IsEmpty":
      return cellValues.every((val) => val.trim() === "");
    case "IsNotEmpty":
      return cellValues.some((val) => val.trim() !== "");
    default:
      return true;
  }
};
